// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__1PwKz","topBottomGutter":"Layout_topBottomGutter__25hIe"};